import React from 'react';
import { COLORS, Color } from '../../../styles/variables';

interface AllroadQuattroDefaultIconProps {
  color?: Color;
}

const AllroadQuattroDefaultIcon: React.FC<AllroadQuattroDefaultIconProps> = ({
  color = COLORS.black,
}) => (
  <svg width="76" height="38" viewBox="0 0 76 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_816_45015)">
      <path
        d="M11.1299 17.22C10.5299 17.22 8.90997 17.31 8.39997 17.39C7.88997 17.47 6.76992 17.73 6.59992 18.07C6.45991 18.4952 6.49231 18.9584 6.69001 19.36C7.54316 19.455 8.40557 19.4247 9.24994 19.27C9.93994 18.67 10.6199 18.07 11.2499 17.48C11.2999 17.39 11.2999 17.22 11.1299 17.22Z"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M23.3499 25.85C23.4084 27.1961 23.0045 28.5216 22.2051 29.6063C21.4058 30.6909 20.2593 31.4693 18.9562 31.812C17.6532 32.1548 16.2722 32.0412 15.0427 31.4901C13.8131 30.9391 12.8092 29.9839 12.1978 28.7832C11.5865 27.5825 11.4045 26.2088 11.6822 24.8903C11.9598 23.5719 12.6803 22.3882 13.7239 21.536C14.7676 20.6839 16.0716 20.2146 17.4189 20.2062C18.7662 20.1979 20.0758 20.6509 21.1299 21.49"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M64.0101 25.85C64.0727 27.201 63.671 28.5328 62.8715 29.6237C62.072 30.7146 60.9231 31.4989 59.6159 31.846C58.3087 32.1932 56.9221 32.0822 55.6867 31.5317C54.4513 30.9812 53.4417 30.0242 52.8259 28.8201C52.21 27.616 52.0249 26.2373 52.3016 24.9134C52.5782 23.5895 53.2999 22.4002 54.3465 21.5435C55.393 20.6868 56.7014 20.2142 58.0539 20.2045C59.4063 20.1948 60.7213 20.6484 61.7801 21.49"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M25.23 14.32C25.23 14.32 37.01 13.72 41.63 13.63L64.86 13.12"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M42.05 8.16L40.51 13.72" stroke={color} strokeWidth="0.75" strokeMiterlimit="10" />
      <path d="M51.36 8.5L54.69 13.37" stroke={color} strokeWidth="0.75" strokeMiterlimit="10" />
      <path
        d="M66.6501 24.74C67.8501 24.57 69.13 24.31 70.75 23.97C72.03 23.71 72.12 20.3 72.12 20.3L71.2701 18.42C71.2701 18.42 71.2701 17.56 71.1801 16.54C71.2839 16.0083 71.261 15.4597 71.1133 14.9385C70.9656 14.4173 70.6974 13.9382 70.3301 13.54C70.3301 13.54 63.6601 8.83999 63.4101 8.74999C62.3448 8.46431 61.2578 8.26698 60.1601 8.15999C44.1001 6.44999 34.71 7.98999 33.25 8.40999C29.8909 9.95043 26.6133 11.6627 23.4301 13.54C18.8279 13.7124 14.2515 14.3116 9.76005 15.33C7.95961 15.7692 6.26154 16.5537 4.76005 17.64C3.40005 18.75 3.31002 21.82 3.48002 23.53C3.65002 25.24 4.94003 25.33 5.62003 25.41L8.35001 25.84"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M49.22 25.42L25.22 25.76" stroke={color} strokeWidth="0.75" strokeMiterlimit="10" />
      <path
        d="M71.01 14.69H67.59C67.5457 14.6924 67.5039 14.7111 67.4725 14.7425C67.4412 14.7738 67.4224 14.8157 67.42 14.86V15.03C67.6473 15.2931 67.8482 15.5778 68.02 15.88C68.3178 16.2876 68.7383 16.589 69.22 16.74C69.8407 16.8199 70.4692 16.8199 71.09 16.74"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_816_45015">
        <rect width="70" height="26" fill="white" transform="translate(3 7)" />
      </clipPath>
    </defs>
  </svg>
);

export default AllroadQuattroDefaultIcon;
